module.exports = __webpack_public_path__ + "img/glass-1.10235728.svg";